import React from 'react';

export const BackUrlContext = React.createContext<string | undefined>(undefined);
